import * as styles from "./SchoolLocationFilters.module.scss";

import { Button, Form } from "../../../components/common";

import React, { useEffect } from "react";
import { useDogSchoolApi } from "../../../context";
import { DISTANCE_OPTIONS } from "../../../context/DogSchoolApi/DogSchoolApi.fixtures";
import LocationInput from "../LocationInput/LocationInput";

export const SchoolLocationFilters: React.FC = () => {
	const {
		dogSchoolLocationsInRange,
		currentDistance,
		allDogSchoolLocations,
		userLocation,
		onUpdateLocation,
		safelyChangeDistance,
		useDogSchoolQuery,
	} = useDogSchoolApi();

	useEffect(() => {
		useDogSchoolQuery();
	}, [useDogSchoolQuery]);

	const items = !userLocation
		? allDogSchoolLocations
		: dogSchoolLocationsInRange;

	return (
		<div className={styles.filters}>
			<h3 className={styles.title}>Find your local dog school</h3>
			<label htmlFor="location-input" className={styles.label}>
				Location <span>(Postcode)</span>
			</label>
			<Form onSubmitFn={() => {}} validationSchema={{}}>
				<LocationInput
					className={styles.searchinput}
					name={"location-input"}
					placeholder={"All of UK"}
					userLocation={userLocation}
					onClearUserLocation={() => onUpdateLocation(null, 1000)}
					onConfirmUserLocation={(location) =>
						onUpdateLocation(
							location,
							currentDistance > 50 ? 50 : currentDistance,
						)
					}
				/>
			</Form>
			<div className={styles.distancecontainer}>
				<label id="distance-input" className={styles.label}>
					Distance
				</label>
				<div className={styles.distancecontrols}>
					<input
						aria-labelledby="distance-input"
						className={styles.distancerange}
						type="range"
						min="10"
						max="50"
						value={!userLocation ? 50 : currentDistance}
						step="10"
						list="steplist"
						onChange={(e) => safelyChangeDistance(e.currentTarget.value)}
						disabled={!userLocation}
					/>
					<datalist id="steplist">
						{DISTANCE_OPTIONS.map((option) => (
							<option key={option} value={option}>
								{option}
							</option>
						))}
					</datalist>
					<select
						aria-labelledby="distance-input"
						className={styles.distanceselect}
						value={currentDistance}
						onChange={(e) => safelyChangeDistance(e.currentTarget.value)}
						disabled={!userLocation}
						style={{}}
					>
						{!userLocation ? (
							<option>Any</option>
						) : (
							<>
								{DISTANCE_OPTIONS.map((option) => (
									<option key={option} value={option}>
										{option} miles
									</option>
								))}
							</>
						)}
					</select>
				</div>
			</div>
			<Button fullWidth={true} url={"/dog-advice/dog-school/search"}>
				{`Show ${items.length} locations`}
			</Button>
		</div>
	);
};

export default SchoolLocationFilters;
